module.exports = __webpack_public_path__ + "img/checkered_flag.0cb33aeb.gif";